module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos do coordenador (disponíveis apenas para os administradores do sistema e para os usuários PROEX)")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail*",
      "counter": "50",
      "rules": _vm.regras50
    },
    model: {
      value: (_vm.contatos.emailCoordenador),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "emailCoordenador", $$v)
      },
      expression: "contatos.emailCoordenador"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone*",
      "counter": "50",
      "rules": _vm.regras50
    },
    model: {
      value: (_vm.contatos.telefoneCoordenador),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "telefoneCoordenador", $$v)
      },
      expression: "contatos.telefoneCoordenador"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('div', {
    staticClass: "tituloSecao"
  }, [_c('label', [_vm._v("Contatos da ação de extensão (as informações de contato abaixo ficarão disponíveis para a consulta pública)")])]) : _vm._e()])], 1), _vm._v(" "), (_vm.administrador === true || _vm.usuarioPROEX === true || _vm.projeto.funcao.item === 1 || _vm.projeto.assessor === true) ? _c('div', [_c('br')]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Site",
      "counter": "100",
      "rules": _vm.regras100
    },
    model: {
      value: (_vm.contatos.site),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "site", $$v)
      },
      expression: "contatos.site"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Instagram",
      "counter": "100",
      "rules": _vm.regras100
    },
    model: {
      value: (_vm.contatos.instagram),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "instagram", $$v)
      },
      expression: "contatos.instagram"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Facebook",
      "counter": "100",
      "rules": _vm.regras100
    },
    model: {
      value: (_vm.contatos.facebook),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "facebook", $$v)
      },
      expression: "contatos.facebook"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Youtube",
      "counter": "100",
      "rules": _vm.regras100
    },
    model: {
      value: (_vm.contatos.youtube),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "youtube", $$v)
      },
      expression: "contatos.youtube"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Outras mídias sociais",
      "rows": "1",
      "auto-grow": "",
      "counter": "100",
      "rules": _vm.regras100
    },
    model: {
      value: (_vm.contatos.midiasSociais),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "midiasSociais", $$v)
      },
      expression: "contatos.midiasSociais"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome do contato",
      "counter": "200",
      "rules": _vm.regras200
    },
    model: {
      value: (_vm.contatos.nomeContato),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "nomeContato", $$v)
      },
      expression: "contatos.nomeContato"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail*",
      "counter": "60",
      "rules": _vm.regras60
    },
    model: {
      value: (_vm.contatos.email),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "email", $$v)
      },
      expression: "contatos.email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Telefone",
      "counter": "30",
      "rules": _vm.regras30
    },
    model: {
      value: (_vm.contatos.telefone),
      callback: function($$v) {
        _vm.$set(_vm.contatos, "telefone", $$v)
      },
      expression: "contatos.telefone"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarContatos(false)
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31971316","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editar-projeto/editar-contatos.vue
// module id = 530
// module chunks = 0